import { render, staticRenderFns } from "./UsuarioForm.vue?vue&type=template&id=160834c0"
import script from "./UsuarioForm.vue?vue&type=script&lang=ts"
export * from "./UsuarioForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports